import { POST_SCHOOL_CANDIDATE_PAYMENT_PAYNOW_PROXY_DETAILS } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { PayNowProxyRequestBody } from '../exam-registration/usePostPayNowProxyDetails';

interface Input {
  onSuccess?: () => void;
  onError?: () => void;
}

export const usePostSchoolCandidatePaymentPayNowProxyDetails = ({ onSuccess, onError }: Input) => {
  const postSchoolCandidatePaymentPayNowProxyDetails = async (
    payNowProxyRequest: PayNowProxyRequestBody
  ) => {
    const res = await axiosClient.post<void>(
      POST_SCHOOL_CANDIDATE_PAYMENT_PAYNOW_PROXY_DETAILS(payNowProxyRequest.uuid),
      payNowProxyRequest.payload
    );

    return res.data;
  };

  return useCustomMutation(postSchoolCandidatePaymentPayNowProxyDetails, {
    onSuccess,
    onError,
  });
};
